export enum DialogType {
    MessageBox,
    Content,
    Template
}
